import { render } from "./manageConfiguration.vue?vue&type=template&id=6369a7d4&scoped=true&ts=true"
import script from "./manageConfiguration.vue?vue&type=script&lang=ts"
export * from "./manageConfiguration.vue?vue&type=script&lang=ts"

import "./manageConfiguration.vue?vue&type=style&index=0&id=6369a7d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6369a7d4"]])

export default __exports__